import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { trackBoth } from "@/lib/meta";
import { PRODUCT } from "@/config/product";

// The ONE primary action on the landing page: go to the Product Page.
// variant: "pill" (pink) | "ink" (dark, for coloured sections) | "ghost".
export default function PreorderCta({
  label = `First Drop Preorder — $${PRODUCT.price}`,
  origin,
  testId,
  variant = "pill",
  size = "lg",
  className = "",
}) {
  const navigate = useNavigate();

  const go = () => {
    trackBoth("CtaClicked", { origin: origin || "cta" });
    navigate("/product");
  };

  if (variant === "ghost") {
    return (
      <button
        data-testid={testId}
        onClick={go}
        className={`inline-flex items-center gap-2 font-display uppercase tracking-wide text-lg underline underline-offset-8 decoration-2 transition-opacity duration-150 hover:opacity-60 ${className}`}
      >
        {label} <ArrowRight className="w-5 h-5" strokeWidth={2.5} />
      </button>
    );
  }

  const colors =
    variant === "ink"
      ? "bg-ink text-ivory"
      : variant === "yellow"
        ? "bg-[#FFD84D] text-ink"
        : "bg-[#FF6BAA] text-ink";

  const sizing =
    size === "sm"
      ? "min-h-[52px] px-6 text-lg"
      : "min-h-[60px] px-8 text-xl";

  return (
    <span className={`inline-flex flex-col items-center gap-1.5 ${className}`}>
      <button
        data-testid={testId}
        onClick={go}
        className={`${sizing} w-full rounded-full border-2 border-ink ${colors} font-display uppercase tracking-wide inline-flex items-center justify-center gap-2 shadow-[3px_3px_0px_#111111] transition-[transform,box-shadow] duration-150 hover:-translate-x-0.5 hover:-translate-y-0.5 hover:shadow-[5px_5px_0px_#111111] active:translate-x-0 active:translate-y-0 active:shadow-[1px_1px_0px_#111111]`}
      >
        {label} <ArrowRight className="w-5 h-5" strokeWidth={2.5} />
      </button>
      <span
        data-testid={testId ? `${testId}-price-note` : undefined}
        className="text-[11px] sm:text-xs text-ink/55 font-medium"
      >
        Regular price ${PRODUCT.launchPrice} after launch.
      </span>
    </span>
  );
}
